import { render, staticRenderFns } from "./BasicQulity.vue?vue&type=template&id=43665150&scoped=true"
import script from "./BasicQulity.vue?vue&type=script&lang=js"
export * from "./BasicQulity.vue?vue&type=script&lang=js"
import style0 from "./BasicQulity.vue?vue&type=style&index=0&id=43665150&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43665150",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43665150')) {
      api.createRecord('43665150', component.options)
    } else {
      api.reload('43665150', component.options)
    }
    module.hot.accept("./BasicQulity.vue?vue&type=template&id=43665150&scoped=true", function () {
      api.rerender('43665150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/report/pdfDataInfo/BasicQulity.vue"
export default component.exports